<template>
    <div class="table">
        <Table size="large" :columns="columns12" :data="list">
            <template slot-scope="{ row }" slot="title">
                <strong>{{ row.title }}</strong>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="error" size="small" @click="remove(row)">删除</Button>
            </template>
        </Table>
    </div>
</template>
<script>
    var self;

    export default {
        name:'table',
        props:{
            list:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data () {
            return {
                columns12: [
                    {
                        title: '祭扫人姓名',
                        slot: 'title',
                        width: 120,
                    },
                    {
                        title: '类型',
                        key: 'typeName',
                        width: 80,
                    },
                    {
                        title: '关系',
                        key: 'relation',
                        width: 80,
                    },
                    {
                        title: '内容',
                        align: 'center',
                        key: 'content',
                    },
                    {
                        title: '祭扫时间',
                        key: 'createTime',
                        width: 150,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 80,
                        align: 'center'
                    }
                ]
            }
        },
        mounted(){
            self = this;
        },
        methods: {
            remove (item) {
                this.$emit('clickRemoveId',item.memorialJiSaoId)
            }
        }
    }
</script>

<style scoped lang="scss">

</style>